// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"d06cf73c","580":"816f1e41"}[chunkId] + ".chunk.css";
};